import { Button, Card, Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Menu, MenuItem, Paper } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import BasicModal from "components/BasicModal";
import DropdownFilter from "components/DropdownFilter";
import EmptyPlaceholder from 'components/EmptyPlaceholder/EmptyPlaceholder';
import EditVendor from "features/vendor/EditVendor";
import { useAddVendorMutation, useGetVendorsQuery } from 'features/vendor/vendorSlice';
import { useState } from "react";
import { mechanicalConfigStyles } from "../../style";

const ClientVendors = ({ mechanicalsConfigParams, vendors, onConfigChange }) => {
    const classes = mechanicalConfigStyles();

    let { data: allVendors, error: vendorsError, isLoading: isLoadingVendors } = useGetVendorsQuery();
    const [addVendor, { isLoading: isAdding }] = useAddVendorMutation();

    const [anchorEl, setAnchorEl] = useState(null);
    const openAddMenu = Boolean(anchorEl);
    const [openNew, setOpenNew] = useState(false);
    const [openSelected, setOpenSelected] = useState(false);
    const [vendorIds, setVendorIds] = useState([]);

    let filteredVendors = [];
    allVendors?.map(sp => {
        if (!(vendors?.find(a => a?.vendorId == sp?.id)))
            filteredVendors.push(sp);
    })

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onAddNewClick = () => {
        handleClose();
        setOpenNew(true)
    }

    const onSelectExistingClick = () => {
        handleClose();
        setOpenSelected(true)
    }

    const handleChange = (event) => {
        setVendorIds(event);
    }


    const onClickDelete = (id) => {
        let updatedVendors = vendors?.filter(vendor => vendor.vendorId != id)
        onConfigChange(undefined, "clientVendors", updatedVendors);
    };

    const handleSaveNew = async (data) => {
        setOpenNew(false);

        let result = await addVendor(data);

        let vendorToAdd = { vendorId: result.data, name: data.name }
        let updatedVendors = vendors?.concat(vendorToAdd);

        onConfigChange(undefined, "clientVendors", updatedVendors);
    }

    const handleCloseExisting = () => {
        setOpenSelected(false);
        setVendorIds([]);
    }

    const handleSaveSelected = async () => {
        setOpenSelected(false)

        let vendorsToAdd = [];
        vendorIds?.forEach((id) => {
            if (!vendors?.some(sp => sp.vendorId === id)) {
                let s = allVendors?.find(vendor => vendor.id == id);
                if (s != null)
                    vendorsToAdd.push({ vendorId: id, name: s.name });
            }
        })
        let updatedVendors = vendors?.concat(vendorsToAdd);

        onConfigChange(undefined, "clientVendors", updatedVendors);
        handleCloseExisting();
    }

    return (
        <Paper className={classes.paper}>
            <Grid container>
                <Grid item xs={9}>
                    <div className={classes.title}>Vendors</div>
                </Grid>
                <Grid item xs={3}>
                    <Authorize profile={permissionProfiles.CLIENT_CONFIG.CLIENT_CONFIG_CHANGE}>
                        <div className={classes.addButton}>
                            <Button
                                disabled={!mechanicalsConfigParams?.useMechanicals}
                                variant="contained"
                                aria-controls={openAddMenu ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={openAddMenu ? 'true' : undefined}
                                onClick={handleClick}
                            >
                                Add Vendor
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={openAddMenu}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                <MenuItem onClick={onAddNewClick}>Add new</MenuItem>
                                <MenuItem onClick={onSelectExistingClick}>Select existing</MenuItem>
                            </Menu>
                        </div>


                        {<EditVendor
                            label="Add New Vendor"
                            open={openNew}
                            setOpen={setOpenNew}
                            onSave={handleSaveNew}
                        />}

                        <BasicModal
                            open={openSelected}
                            header={`Select Vendor`}
                            handleClose={handleCloseExisting}
                            component={
                                <div className={classes.selectVendors}>
                                    <DropdownFilter
                                        title={'Vendors'}
                                        values={filteredVendors}
                                        onSelect={(val) => handleChange(val)}
                                        value={vendorIds}
                                        multiple={true}
                                        className={classes.multiSelect}
                                    />
                                    <div className={classes.selectActionButtons}>
                                        <Button onClick={handleCloseExisting} color="primary">
                                            Cancel
                                        </Button>
                                        <Button onClick={handleSaveSelected} color="primary" variant="contained">
                                            Save
                                        </Button>
                                    </div>
                                </div>
                            }
                        />
                    </Authorize>
                </Grid>
            </Grid>
            <List>
                {vendors?.length ?
                    <>{vendors?.map(vendor =>
                        <Card className={classes.listItem}>
                            <ListItem key={vendor?.id} className={classes.spacing}>
                                <ListItemText primary={vendor?.name} />
                                <Authorize profile={permissionProfiles.CLIENT_CONFIG.CLIENT_CONFIG_CHANGE}>
                                    <ListItemSecondaryAction>
                                        <IconButton edge="end" aria-label="delete"
                                            disabled={!mechanicalsConfigParams?.useMechanicals}
                                            onClick={() => onClickDelete(vendor?.vendorId)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>

                                    </ListItemSecondaryAction>
                                </Authorize>
                            </ListItem>
                        </Card>
                    )}</> :
                    <EmptyPlaceholder text='No Vendors' />
                }
            </List>
        </Paper>
    );
}

export default ClientVendors;